module.exports = __webpack_public_path__ + "img/cbs.2de72e63.png";